const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/header.jsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "animate.css";
import "./style/header.css";
import { Container, Navbar, Nav, Image, Col, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import headerLogo from "../../assets/images/headertop_logo.png";
import MenuButton from "./modal/menu_button";
import NoticeButton from "./modal/notice_button";
import homeIcon from "../../assets/images/homeicon.png";
import UserMenu from "./modal/user_menu";
import SearchPopup from "./modal/search_popup";
import {
    apiGetNotificationsCount,
    apiGetUserNotifications,
} from "../../services/api/notification";
import {
    LANGUAGE_CHANGED_EVENT,
    LANGUAGE_STORAGE_KEY,
    SUPPORTED_LANGUAGES,
    normalizeLanguage,
} from "../../i18n/language";

const CONTACT_EMAIL = "admin@trinitech.co.th";

function HeaderTop(props) {
    const { t, i18n } = useTranslation();
    const [authorized, setAuthorized] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [noticeCount, setNoticeCount] = useState([]);
    const currentLanguage = normalizeLanguage(
        i18n.resolvedLanguage || i18n.language
    );
    const languageOptions = SUPPORTED_LANGUAGES.map((language) => ({
        ...language,
        label: t(`header.languages.${language.code}`),
    }));

    const homebtn = async () => {
        console.log("home redirect called");
        setTimeout(() => {
            const cleanUrl = new URL(process.env.REACT_APP_SOCIAL_URL);
            window.location.replace(cleanUrl.origin);
        }, 500);
    };

    const loadNotice = async () => {
        let notification = await apiGetUserNotifications();
        setNotifications(notification.data);
        let count = await apiGetNotificationsCount();
        setNoticeCount(count.data);
    };

    const showContactUs = async () => {
        Swal.fire({
            title: "",
            text: t("header.contactEmail", { email: CONTACT_EMAIL }),
            imageUrl:
                "http://www.trinitech.co.th/th/wp-content/uploads/2010/10/TrinLOGOs1.png",
            imageAlt: "",
            showClass: {
                popup: "animate__animated animate__zoomIn animate__faster",
            },
            hideClass: {
                popup: "animate__animated animate__zoomOut animate__faster",
            },
            confirmButtonColor: "#28825A",
        });
    };

    const changeLanguage = (language) => {
        const nextLanguage = normalizeLanguage(language);

        i18n.changeLanguage(nextLanguage);
        localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
        window.dispatchEvent(
            new CustomEvent(LANGUAGE_CHANGED_EVENT, {
                detail: nextLanguage,
            })
        );
    };

    const selectedLanguageTemplate = (option) => {
        const selectedLanguage =
            option ||
            languageOptions.find(
                (language) => language.code === currentLanguage
            );

        if (!selectedLanguage) {
            return null;
        }

        return (
            React.createElement('div', { className: "language-dropdown-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
                , React.createElement('span', { className: "language-dropdown-code", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
                    , selectedLanguage.shortLabel
                )
                , React.createElement('span', { className: "language-dropdown-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
                    , selectedLanguage.label
                )
            )
        );
    };

    const languageOptionTemplate = (option) => (
        React.createElement('div', { className: "language-dropdown-option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
            , React.createElement('span', { className: "language-dropdown-code", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, option.shortLabel)
            , React.createElement('span', { className: "language-dropdown-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}, option.label)
            , React.createElement('span', { className: "language-dropdown-native", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
                , option.nativeLabel
            )
        )
    );

    useEffect(() => {
        setAuthorized(
            localStorage.getItem("token") ||
                localStorage.getItem("skillmeo_token") ||
                localStorage.getItem("mooc_token") ||
                localStorage.getItem("social_token")
        );
        if (localStorage.getItem("social_token")) {
            loadNotice();
        }
    }, []);

    const hashtag = _optionalChain([props, 'optionalAccess', _ => _.hashtag]);
    const mobileSearchInline = _optionalChain([props, 'optionalAccess', _2 => _2.mobileSearchInline]) !== false;

    const languageSelector = (
        React.createElement('div', { className: "menu-group language-selector-group" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
            , React.createElement(Dropdown, {
                value: currentLanguage,
                options: languageOptions,
                optionLabel: "label",
                optionValue: "code",
                onChange: (event) => changeLanguage(event.value),
                valueTemplate: selectedLanguageTemplate,
                itemTemplate: languageOptionTemplate,
                className: "language-dropdown",
                panelClassName: "language-dropdown-panel",
                ariaLabel: t("header.language"),
                title: t("header.language"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}
            )
        )
    );

    return (
        React.createElement(Navbar, {
            expand: "sm",
            style: {
                fontWeight: "600",
                fontSize: "20px",
                zIndex: "10000",
                position: "sticky",
                top: "0px",
            },
            className: `p-0 ${authorized ? "header" : "header-top"} ${
                props.currentPage ? "header" : ""
            } ${
                mobileSearchInline && authorized
                    ? "header-mobile-search-inline"
                    : ""
            }`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}

            , React.createElement(Container, { fluid: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
                , React.createElement(Row, {
                    className: `d-flex w-100 ${
                        authorized
                            ? "justify-content-between ml-3"
                            : "justify-content-end"
                    }`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}

                    , React.createElement(Col, {
                        xs: mobileSearchInline && authorized ? 3 : 1,
                        sm: mobileSearchInline && authorized ? 5 : undefined,
                        md: 5,
                        className: `d-flex flex-row header-brand-column ${authorized ? "" : "mr-6"}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}

                        , React.createElement(Navbar.Brand, { onClick: homebtn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
                            , React.createElement(Image, {
                                src: headerLogo,
                                className: "header-logo",
                                alt: "logo", __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
                            )
                        )
                        , React.createElement('div', { className: "d-flex flex-column align-self-end"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
                            , React.createElement('small', { className: "d-none d-md-block text-color-ms"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}
                                , t("header.brand")
                            )
                            , React.createElement('small', { className: "d-none d-md-block text-color-ms"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}
                                , t("header.tagline")
                            )
                        )
                    )
                    , React.createElement(Col, {
                        xs: 9,
                        sm: mobileSearchInline && authorized ? 7 : undefined,
                        md: 5,
                        className: `d-flex justify-content-end ${
                            authorized ? "mr-3 mb-2" : ""
                        } ${mobileSearchInline ? "header-actions-column" : ""}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}

                        , React.createElement(Navbar.Collapse, { className: "basic-navbar-nav justify-content-end align-self-end navbar-text text-center"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}
                            , authorized && (
                                React.createElement('div', { className: "d-none d-md-block" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
                                    , React.createElement(SearchPopup, { hashtag: hashtag, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}} )
                                )
                            )
                            , languageSelector
                            , authorized ? (
                                React.createElement(React.Fragment, null
                                    , React.createElement('div', { className: "menu-group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
                                        , React.createElement(Image, {
                                            onClick: homebtn,
                                            className: "menu-icon",
                                            src: homeIcon,
                                            alt: t("header.home"),
                                            title: t("header.home"),
                                            width: "55px",
                                            height: "45px", __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
                                        )
                                    )
                                    , React.createElement(MenuButton, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 226}} )
                                    , React.createElement(NoticeButton, {
                                        notifications: notifications,
                                        count: noticeCount,
                                        loadNotice: loadNotice, __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
                                    )
                                    , React.createElement(UserMenu, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 232}} )
                                )
                            ) : (
                                React.createElement(Nav, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
                                    , React.createElement(Nav.Link, {
                                        className: "navbar-link-custom",
                                        onClick: showContactUs, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}

                                        , t("header.contactUs")
                                    )
                                )
                            )
                        )
                        , authorized && mobileSearchInline && (
                            React.createElement('div', { className: "mobile-header-search-inline d-sm-none" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
                                , React.createElement(SearchPopup, {
                                    hashtag: hashtag,
                                    className: "header-search-popup-inline", __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
                                )
                            )
                        )
                        , React.createElement(Navbar.Toggle, { 'aria-controls': "basic-navbar-nav", __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}} )
                    )
                )
                , authorized && !mobileSearchInline && (
                    React.createElement(Row, { className: "d-sm-none mt-2 px-2 m-auto text-center"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
                        , React.createElement(Col, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}
                            , React.createElement(SearchPopup, { hashtag: hashtag, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}} )
                        )
                    )
                )
            )
        )
    );
}

export default HeaderTop;
